module.exports = __webpack_public_path__ + "static/media/nanjing.66974181.jpg";